/**
 * Bundle PDP — included model cards + detail modal.
 * Dialog is portaled to <body>; display:contents lets backdrop + panel stack correctly.
 */
(function () {
  var SPEC_FIELDS = [
    { key: 'brand', label: 'Brand' },
    { key: 'scale', label: 'Scale' },
    { key: 'sku', label: 'SKU' },
    { key: 'material', label: 'Material' },
    { key: 'color', label: 'Color' }
  ];

  function parseImages(button) {
    var raw = button.dataset.images || button.dataset.image || '';
    if (!raw) return [];
    return raw.split('|').filter(Boolean);
  }

  function initSection(section) {
    var wrap = section.closest('.grail-bundle-includes-wrap');
    var dialog = wrap && wrap.querySelector('[data-grail-bundle-dialog]');
    if (!dialog) return;

    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    var backdrop = dialog.querySelector('.grail-bundle-includes__dialog-backdrop');
    var panel = dialog.querySelector('.grail-bundle-includes__dialog-panel');
    var closeBtn = dialog.querySelector('.grail-bundle-includes__dialog-close');
    var img = dialog.querySelector('[data-grail-bundle-dialog-img]');
    var titleEl = dialog.querySelector('[data-grail-bundle-dialog-title]');
    var specsEl = dialog.querySelector('[data-grail-bundle-dialog-specs]');
    var aboutEl = dialog.querySelector('[data-grail-bundle-dialog-about]');
    var aboutTextEl = dialog.querySelector('[data-grail-bundle-dialog-about-text]');
    var prevBtn = dialog.querySelector('[data-grail-bundle-prev]');
    var nextBtn = dialog.querySelector('[data-grail-bundle-next]');
    var countEl = dialog.querySelector('[data-grail-bundle-image-count]');

    var lastTrigger = null;
    var images = [];
    var imageIndex = 0;
    var imageAlt = '';
    var touchStartX = 0;

    function buildSpecs(button) {
      if (!specsEl) return;
      specsEl.innerHTML = '';

      SPEC_FIELDS.forEach(function (field) {
        var value = button.dataset[field.key];
        if (!value) return;

        var row = document.createElement('div');
        row.className = 'grail-bundle-includes__spec';

        var dt = document.createElement('dt');
        dt.textContent = field.label;

        var dd = document.createElement('dd');
        dd.textContent = value;

        row.appendChild(dt);
        row.appendChild(dd);
        specsEl.appendChild(row);
      });
    }

    function setAbout(button) {
      var description = button.dataset.description || '';
      if (!aboutEl || !aboutTextEl) return;

      if (!description) {
        aboutEl.hidden = true;
        aboutTextEl.textContent = '';
        aboutEl.removeAttribute('open');
        return;
      }

      aboutTextEl.textContent = description;
      aboutEl.hidden = false;
      aboutEl.removeAttribute('open');
    }

    function updateImageNav() {
      var hasMany = images.length > 1;
      if (prevBtn) prevBtn.hidden = !hasMany;
      if (nextBtn) nextBtn.hidden = !hasMany;
      if (countEl) {
        if (hasMany) {
          countEl.hidden = false;
          countEl.textContent = imageIndex + 1 + ' / ' + images.length;
        } else {
          countEl.hidden = true;
          countEl.textContent = '';
        }
      }
    }

    function showImage(index) {
      if (!img || !images.length) return;
      imageIndex = (index + images.length) % images.length;
      img.src = images[imageIndex];
      img.alt = imageAlt || '';
      updateImageNav();
    }

    function open(button) {
      if (!button) return;
      lastTrigger = button;
      images = parseImages(button);
      imageAlt = button.dataset.imageAlt || button.dataset.title || '';
      imageIndex = 0;

      if (titleEl) titleEl.textContent = button.dataset.title || '';
      buildSpecs(button);
      setAbout(button);

      if (img) {
        if (images.length) {
          showImage(0);
        } else {
          img.removeAttribute('src');
          img.alt = '';
          updateImageNav();
        }
      }

      dialog.hidden = false;
      document.body.classList.add('grail-bundle-includes-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.add('is-open');
          dialog.setAttribute('aria-hidden', 'false');
          if (closeBtn) closeBtn.focus();
        });
      });
    }

    function close() {
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('grail-bundle-includes-open');

      window.setTimeout(function () {
        if (!dialog.classList.contains('is-open')) {
          dialog.hidden = true;
        }
        if (lastTrigger) lastTrigger.focus();
      }, 280);
    }

    section.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-grail-bundle-open]');
      if (openBtn) {
        event.preventDefault();
        open(openBtn);
      }
    });

    if (backdrop) {
      backdrop.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        close();
      });
    }

    if (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showImage(imageIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showImage(imageIndex + 1);
      });
    }

    var media = dialog.querySelector('.grail-bundle-includes__dialog-media');
    if (media) {
      media.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].screenX;
        },
        { passive: true }
      );

      media.addEventListener(
        'touchend',
        function (event) {
          if (images.length < 2) return;
          var delta = event.changedTouches[0].screenX - touchStartX;
          if (Math.abs(delta) < 40) return;
          if (delta < 0) showImage(imageIndex + 1);
          else showImage(imageIndex - 1);
        },
        { passive: true }
      );
    }

    document.addEventListener('keydown', function (event) {
      if (!dialog.classList.contains('is-open')) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') showImage(imageIndex - 1);
      if (event.key === 'ArrowRight') showImage(imageIndex + 1);
    });
  }

  function init() {
    document.querySelectorAll('[data-grail-bundle-includes]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
